import { render, staticRenderFns } from "./ImportExportDown.vue?vue&type=template&id=65f5a4a2&scoped=true&"
import script from "./ImportExportDown.vue?vue&type=script&lang=js&"
export * from "./ImportExportDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5a4a2",
  null
  
)

export default component.exports